import ActionsBuilder from '../../../../utils/actions/ActionsBuilder';
import { createActionName } from '../../../../core/store/actions/commonActionTypes';
import { IAwardApplicationActionPayload } from '../../../../core/interfaces/model';

export const IDENTIFIER = '[MANAGE_AWARD_APPLICATIONS]';
export const DO_ACTION = 'DO_ACTION';

export default {
    ...ActionsBuilder.buildList(IDENTIFIER, false, false, false),
    doAction: (data: IAwardApplicationActionPayload) => ({
        type: createActionName(IDENTIFIER, DO_ACTION),
        payload: data
    })
};
